import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-itfacilitychecker-decline-grid',
  templateUrl: './itfacilitychecker-decline-grid.component.html',
  styleUrls: ['./itfacilitychecker-decline-grid.component.scss']
})
export class ITfacilitycheckerDeclineGridComponent implements OnInit {

  constructor(public appservice:AppService,public router:Router) { }

  
  editEmployee(id:any){
    //this.appservice.get_Microsoft360_ITfacilityeditdata(id);
    this.appservice.ITfacilitycheckerclosereditid=id;
    console.log("the edit id",this.appservice.Microsoft360editid)
    this.router.navigateByUrl('/home/itfacilitychecker-decline');
  }
  
  ngOnInit(): void {
      this.appservice.getITfacilitycheckercloser_grid();
  }

}
